import makeBasicTheme from '../makeBasicTheme'
const mainColor = "#009fdb"
export default makeBasicTheme(mainColor)